import { get } from 'lodash';
import * as contentGroupsEnums from './contentGroups';
import contentGroupMap from './contentGroupMap';
import getGAClientId from './getGAClientId';

function setIntervalX(callback, delay, repetitions) {
  let x = 0;
  let intervalID = window.setInterval(() => {
    callback();
    if (++x === repetitions) {
      window.clearInterval(intervalID);
    }
  }, delay);
}

// https://segment.com/docs/destinations/google-analytics/#content-groupings
export default async function trackPageView({
  contentCreationMethod,
  contentGroup,
  contentLocalized,
  contentTopics = [],
  searchTermTarget,
  wordCount,
}) {
  let trackingCallMade = false;

  return setIntervalX(async () => {
    if (trackingCallMade === true) return;
    if (window.analytics == null) return;
    if (window.analytics.user == null) return;
    try {
      if (contentGroup == null) {
        console.warn('No content group specified.');
      }
      if (!Object.values(contentGroupsEnums).includes(contentGroup)) {
        console.warn(`Not a content grouping: ${contentGroup}`)
      }

      // Page Event
      const pageProps = {
        path: location.pathname,
        referrer: document.referrer,
        title: document.title,
        url: location.href,
      };
      // - Google Analytics Content Grouping
      if (contentGroup != null) {
        pageProps[contentGroupMap[contentGroup]] = contentGroup;
      }
      const gaClientId = await getGAClientId();
      if (gaClientId != null) {
        pageProps.context = {
          'Google Analytics': {
            clientId: gaClientId,
          },
        };
      }

      // Traits Updating
      const thisInteraction = {
        interactionType: 'pageView',
        contentCreationMethod,
        contentGroup,
        contentLocalized,
        contentTopics,
        interactionAt: new Date(),
        path: location.pathname,
        searchTermTarget,
        wordCount,
      };
      const userTraits = await window.analytics.user().traits();
      const newTraits = {
        allInteractions: get(userTraits, 'allInteractions', [])
          .concat(thisInteraction),
        numInteractions: get(userTraits, 'numInteractions', 0) + 1,
        lastInteraction: thisInteraction,
      };
      // If no firstInteraction was set, this is a new user and should set
      if (userTraits.firstInteraction == null) {
        newTraits.firstInteraction = thisInteraction;
      }

      // Update!
      await window.analytics.page(pageProps);
      await window.analytics.identify(newTraits);
      trackingCallMade = true;
    } catch (e) {
      console.error(e);
    }
  }, 600, 4);
}
